module.exports = __webpack_public_path__ + "static/media/TG.6b5c6ae5.svg";